var React = require('react');

function GoPaperLessIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"ICON - Paperless Bill","stroke":"#27788C","strokeLinejoin":"round","strokeWidth":"2"},[React.createElement("path",{"data-name":"Path 2837","d":"M31.215 1c3.45 7.573 1.268 21.268-7.22 28.074-6.356 5.1-15.282 4.847-20.046-.689S.437 14.179 6.743 9.023 23.209 6.931 31.215 1Z","fill":"#d0e8f9","key":0}),React.createElement("path",{"data-name":"Path 2838","d":"M1.056 35.369c.486-8.364 8.772-16.649 18.506-18.506","fill":"none","strokeLinecap":"round","key":1})]));
}

GoPaperLessIcon.defaultProps = {"width":"33.842","height":"36.426"};

module.exports = GoPaperLessIcon;

GoPaperLessIcon.default = GoPaperLessIcon;
